var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonarkLogoShort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 19,
    viewBox: "0 0 46 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.44268 15.4485C8.44859 15.4485 10.8854 12.9964 10.8854 9.97151C10.8854 6.94671 8.44859 4.49463 5.44268 4.49463C2.43677 4.49463 0 6.94671 0 9.97151C0 12.9964 2.43677 15.4485 5.44268 15.4485Z",
    fill: "#FCBE1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.2837 18.259V2.5256L19.5283 2.42302L20.2418 2.15635C20.5271 2.03328 20.8737 1.93071 21.261 1.80764C21.6483 1.68456 22.0968 1.56148 22.5859 1.43841C23.0752 1.31533 23.6052 1.19225 24.1352 1.08969C24.6855 0.987126 25.2767 0.90507 25.9087 0.843534C26.5405 0.781998 27.1725 0.740967 27.8044 0.740967C29.4556 0.740967 30.8417 1.06917 31.9832 1.74609C33.9402 1.06917 35.9378 0.740967 37.9559 0.740967C40.3613 0.740967 42.2367 1.35635 43.6024 2.6076C44.9682 3.85888 45.6409 5.68456 45.6409 8.08456V18.259H39.7293V7.8384C39.7293 6.05376 38.9344 5.17176 37.3648 5.17176C36.4678 5.17176 35.6729 5.27432 35.0001 5.49992C35.2856 6.36152 35.4283 7.20248 35.4283 7.982C35.4283 8.02304 35.4283 8.04352 35.4283 8.06408V18.2384H29.5167V7.75632C29.5167 6.07432 28.7829 5.23328 27.3152 5.23328C27.2948 5.23328 27.2948 5.23328 27.2744 5.23328C26.6629 5.23328 25.9698 5.33584 25.2156 5.54096V18.2384H19.2837V18.259Z",
    fill: "#395966"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonarkLogoShort);
export default __webpack_public_path__ + "static/media/monarkLogoShort.9f29f3d31bbc2c522f2efad0541b1d24.svg";
export { ForwardRef as ReactComponent };